<template>
  <v-container fluid>
    <v-progress-linear
      v-if="$vars.loading"
      indeterminate
      class="primary--text loader"
    ></v-progress-linear>
    <v-toolbar dense flat>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on"><v-icon>add</v-icon></v-btn>
        </template>
        <v-list dense>
          <v-list-item 
            link 
            v-for="(item, index) in dokumentArten" 
            :key="index"
            @click="
              (showNeuesDokument = true) && 
              (neuesDokument = neuesDokumentDefault) && 
              (neuesDokument.art = item.value) && 
              (isNew = true)
            "
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.titel }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.beschreibung }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-text-field
          v-model='search'
          append-icon='search'
          label='Suchen'
          single-line
          solo
          flat
          hide-details
          clearable
          clear-icon="close"
        ></v-text-field>
      </v-toolbar-items>
      <v-chip small label color="green" dark>BETA</v-chip>
    </v-toolbar>

    
    <v-row class="ma-0">
      <v-col cols="4" v-for="(item, index) in dokumente" :key="index">
        <v-card outlined class="rounded-lg">
          <v-card-title>
            {{ item.titel }}
          </v-card-title>
          <v-card-subtitle>{{ dokumentArten.find(key => key.value === item.art).text }}</v-card-subtitle>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="(showNeuesDokument = true) && (neuesDokument = item) && (isNew = false)"><v-icon>edit</v-icon></v-btn>
            <v-btn icon class="primary--text" @click="(neuesDokument = item) && (printDokument())"><v-icon>download</v-icon></v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showNeuesDokument"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="70%"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title v-if="isNew">
          Neues Dokument erstellen
          <v-spacer></v-spacer>
          <v-btn icon @click="showNeuesDokument = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-title v-else>
          {{ neuesDokument.titel }} bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="showNeuesDokument = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12"><v-text-field hide-details outlined dense v-model="neuesDokument.titel" label="Titel"></v-text-field></v-col>
            <v-col cols="12"><v-select hide-details outlined dense :items="dokumentArten" v-model="neuesDokument.art" label="Art"></v-select></v-col>
            <v-col cols="12">
              <span v-if="neuesDokument.art === 'kommerseinladung'">
                Die Kommerseinladung ist eine 4 Seitige DIN-Lang Klappkarte. Es wird ein PDF mit zwei Seiten im Format 
                204 x 216 mm generiert. Auf der ersten Seite befindet sich die Vorder- und Rückseite und auf der zweiten 
                Seite der Innenteil. Die Text können frei angepasst werden. Enter zwischen den Worten sowie Leerzeilen 
                werden berücksichtigt.
              </span>
              <span v-if="neuesDokument.art === 'tagesordnung'">
                Die Tagesordnung ist auf wird auf einer A4 Seite dargestellt. Dabei kann sowohl vor als auch nach den 
                Tagesordnungspunkten ein Freitext hinzugefügt werden.
              </span>
              <span v-if="neuesDokument.art === 'rundbriefohneansprache'">
                Der Rundbrief kann eine oder mehrere A4-Seiten umfassen. Es wird keine Adresse der Bundesbrüder eingefügt. 
                Als Absender dient der ausgewählte Kontakt sowie das eingetragene Amt. Bei Mehrseitigen Dokumenten wird eine
                Seitenzahl eingefügt.
              </span>
            </v-col>

          </v-row>
          <v-divider></v-divider>
          <v-row no-gutters v-if="neuesDokument.art === 'kommerseinladung'">
            <v-col cols="3" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.titel1" label="Titelzeile 1"></v-text-field></v-col>
            <v-col cols="3" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.titel2" label="Titelzeile 2"></v-text-field></v-col>
            <v-col cols="3" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.titel3" label="Titelzeile 3"></v-text-field></v-col>
            <v-col cols="3" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.titel4" label="Titelzeile 4"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.titel5" label="Untertitel 1"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-textarea hide-details outlined dense v-model="neuesDokument.data.anschreiben" label="Anschreiben"></v-textarea></v-col>
            <v-col cols="6" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.senior" label="Senior"></v-text-field></v-col>
            <v-col cols="6" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.philsenior" label="Philsterenior"></v-text-field></v-col>
            <v-col cols="4" class="pa-2">
              <v-text-field class="pb-2" hide-details outlined dense v-model="neuesDokument.data.tag1" label="Tag 1"></v-text-field>
              <v-textarea hint="Veranstaltungspunkte mit Enter trennen." outlined dense v-model="neuesDokument.data.tag1programm" label="Tag 1 Programm"></v-textarea>
            </v-col>
            <v-col cols="4" class="pa-2">
              <v-text-field class="pb-2" hide-details outlined dense v-model="neuesDokument.data.tag2" label="Tag 2"></v-text-field>
              <v-textarea hint="Veranstaltungspunkte mit Enter trennen." outlined dense v-model="neuesDokument.data.tag2programm" label="Tag 2 Programm"></v-textarea>
            </v-col>
            <v-col cols="4" class="pa-2">
              <v-text-field class="pb-2" hide-details outlined dense v-model="neuesDokument.data.tag3" label="Tag 3"></v-text-field>
              <v-textarea hint="Veranstaltungspunkte mit Enter trennen." outlined dense v-model="neuesDokument.data.tag3programm" label="Tag 3 Programm"></v-textarea>
            </v-col>
            <v-col cols="12" class="pa-2"><v-textarea hide-details outlined dense v-model="neuesDokument.data.anmerkung" label="Anmerkung"></v-textarea></v-col>
          </v-row>
          <v-row no-gutters v-if="neuesDokument.art === 'tagesordnung'">
            <v-col cols="12" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.ueberschrift" label="Überschrift"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-textarea hide-details outlined dense v-model="neuesDokument.data.freitext1" label="Freitext 1"></v-textarea></v-col>
            <v-col cols="12" class="pa-2" v-for="index in neuesDokument.data.tops.length + 1" :key="index">
              <v-text-field hide-details outlined dense v-model="neuesDokument.data.tops[index - 1]" :prefix="'TOP ' + index"></v-text-field>
            </v-col>
            <v-col cols="12" class="pa-2"><v-textarea hide-details outlined dense v-model="neuesDokument.data.freitext2" label="Freitext 2"></v-textarea></v-col>
          </v-row>
          <v-row no-gutters v-if="neuesDokument.art === 'rundbriefohneansprache'">
            <v-col cols="6" class="pa-2"><v-select hide-details outlined dense :items="selectBbrBbr" v-model="neuesDokument.data.absender" label="Absender"></v-select></v-col>
            <v-col cols="6" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.position" label="Position"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.ueberschrift" label="Überschrift"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-textarea hide-details outlined dense rows="10" v-model="neuesDokument.data.freitext" label="Freitext 1"></v-textarea></v-col>
          </v-row>
          <v-row no-gutters v-if="neuesDokument.art === 'rundbrief160'">
            <v-col cols="6" class="pa-2"><v-select hide-details outlined dense :items="selectBbrBbr" v-model="neuesDokument.data.absender" label="Absender"></v-select></v-col>
            <v-col cols="6" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.position" label="Position"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-text-field hide-details outlined dense v-model="neuesDokument.data.ueberschrift" label="Überschrift"></v-text-field></v-col>
            <v-col cols="12" class="pa-2"><v-textarea hide-details outlined dense rows="10" v-model="neuesDokument.data.freitext" label="Freitext 1"></v-textarea></v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn @click="printDokument()">Drucken</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="showNeuesDokument = false">Abbrechen</v-btn>
          <v-btn class="primary" text v-if="isNew" @click="createDokument()">Speichern</v-btn>
          <v-btn class="primary" text v-else @click="updateDokument()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

   
  </v-container>
</template>

<script>
  import JSPDF from 'jspdf'
  export default {
    data () {
      return {
        search: null,
        isNew: null,
        neuesDokumentDefault: {
          datum: new Date(),
          data: {
            tops: []
          }
        },
        neuesDokument: {
          datum: new Date(),
          data: {
            tops: []
          }
        },
        dokumentArten: [{
          titel: 'Rundbrief (ohne persönliche Ansprache)',
          beschreibung: 'DIN A4',
          text: 'Rundbrief, DIN A4',
          value: 'rundbriefohneansprache'
        }, {
          titel: 'Kommerseinladung Faltkarte',
          beschreibung: 'DIN-Lang, 4-Seitig, Vorschau und Druckversion',
          text: 'Kommerseinladung, DIN-Lang, 4-Seitig, Vorschau und Druckversion',
          value: 'kommerseinladung'
        }, {
          titel: 'Tagesordnung',
          beschreibung: 'DIN A4, für alle Convente',
          text: 'Tagesordnung, DIN A4, für alle Convente',
          value: 'tagesordnung'
        }, {
          titel: 'Rundbrief 160 Stiftungsfest',
          beschreibung: 'DIN A4',
          text: 'Rundbrief, DIN A4',
          value: 'rundbrief160'
        }],
        showNeuesDokument: false
      }
    },
    computed: {
      dokumente () {
        if (this.$store.state.dokumente.loaded === false) {
          this.$store.dispatch('dokumente/loadDokumente')
        }
        return this.$store.state.dokumente.dokumente
      },
      selectBbrBbr () {
        let selectBbrBbr = []
        this.$store.getters['bbrbbr/nurBbrbbr'].forEach(bbr => {
          selectBbrBbr.push({
            id: bbr.id,
            value: bbr.id,
            name: bbr.nachname + ', ' + bbr.vorname,
            text: bbr.nachname + ', ' + bbr.vorname
          })
        })
        return selectBbrBbr
      }
    },
    methods: {
      createDokument () {
        this.$store.dispatch('dokumente/createDokument', this.neuesDokument)
        this.neuesDokument = this.neuesDokumentDefault
        this.showNeuesDokument = false
      },
      updateDokument () {
        this.$store.dispatch('dokumente/updateDokumentData', this.neuesDokument)
        this.neuesDokument = this.neuesDokumentDefault
        this.showNeuesDokument = false
      },
      printDokument () {
        if (this.neuesDokument.art === 'kommerseinladung') {
          this.printKommerseinladung()
        }
        if (this.neuesDokument.art === 'tagesordnung') {
          this.printTagesordnung()
        }
        if (this.neuesDokument.art === 'rundbriefohneansprache') {
          this.printRundbriefohneansprache()
        }
        if (this.neuesDokument.art === 'rundbrief160') {
          this.printBrief160()
        }
      },
      printKommerseinladung () {
        let doc = new JSPDF('p', 'mm', [204, 216])
        doc.setFont('Times')
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 195, 204, 3, 'F')
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 195, 204, 3, 'F')
        doc.setFillColor(219, 31, 41)
        doc.rect(0, 201, 204, 3, 'F')
        let img = new Image()
        img.src = '/static/wappen.png'
        doc.addImage(img, 111.5, 52, 80, 80)
        let img2 = new Image()
        img2.src = '/static/zirkel.png'
        doc.addImage(img2, 21, 50, 58, 96)
        doc.setFontSize(36)
        this.neuesDokument.data.titel1 ? doc.text(this.neuesDokument.data.titel1, 151.5, 25, null, null, 'center') : ''
        this.neuesDokument.data.titel2 ? doc.text(this.neuesDokument.data.titel2, 151.5, 40, null, null, 'center') : ''
        this.neuesDokument.data.titel3 ? doc.text(this.neuesDokument.data.titel3, 151.5, 150, null, null, 'center') : ''
        this.neuesDokument.data.titel4 ? doc.text(this.neuesDokument.data.titel4, 151.5, 165, null, null, 'center') : ''
        doc.setFontSize(18)
        this.neuesDokument.data.titel5 ? doc.text(this.neuesDokument.data.titel5, 151.5, 180, null, null, 'center') : ''
        doc.addPage()
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 195, 204, 3, 'F')
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 195, 204, 3, 'F')
        doc.setFillColor(219, 31, 41)
        doc.rect(0, 201, 204, 3, 'F')
        doc.setFontSize(14)
        let lines1 = doc.splitTextToSize(this.neuesDokument.data.anschreiben, 79)
        let zeile = 99 - 0.5 * (parseInt((parseInt(6) * lines1.length) / 2) + 12 + 30)
        doc.text(lines1, 52.5, zeile, null, null, 'center')
        zeile = 99 + 0.5 * (parseInt((parseInt(6) * lines1.length) / 2) + 12 + 30)
        doc.text('für die Aktivitas', 27.75, zeile, null, null, 'center')
        this.neuesDokument.data.senior ? doc.text(this.neuesDokument.data.senior, 27.75, zeile + 6, null, null, 'center') : ''
        doc.text('Senior', 27.75, zeile + 12, null, null, 'center')
        doc.text('für den AHV', 77.25, zeile, null, null, 'center')
        this.neuesDokument.data.philsenior ? doc.text(this.neuesDokument.data.philsenior, 77.25, zeile + 6, null, null, 'center') : ''
        doc.text('Philistersenior', 77.25, zeile + 12, null, null, 'center')
        zeile = 13
        doc.lineHeightProportion = 1.5
        doc.setFont('Times', 'bold')
        this.neuesDokument.data.tag1 ? doc.text(this.neuesDokument.data.tag1, 151.5, zeile, null, null, 'center') : ''
        doc.setFont('Times', 'normal')
        let lines2 = this.neuesDokument.data.tag1programm ? doc.splitTextToSize(this.neuesDokument.data.tag1programm, 79) : ''
        doc.text(lines2, 151.5, zeile + 10, {lineHeightFactor: 1.5, align: 'center'})
        zeile += parseInt((parseInt(7) * lines2.length)) + 15
        doc.setFont('Times', 'bold')
        this.neuesDokument.data.tag2 ? doc.text(this.neuesDokument.data.tag2, 151.5, zeile, null, null, 'center') : ''
        doc.setFont('Times', 'normal')
        let lines3 = this.neuesDokument.data.tag2programm ? doc.splitTextToSize(this.neuesDokument.data.tag2programm, 79) : ''
        doc.text(lines3, 151.5, zeile + 10, {lineHeightFactor: 1.5, align: 'center'})
        zeile += parseInt((parseInt(7) * lines3.length)) + 15
        doc.setFont('Times', 'bold')
        this.neuesDokument.data.tag3 ? doc.text(this.neuesDokument.data.tag3, 151.5, zeile, null, null, 'center') : ''
        doc.setFont('Times', 'normal')
        let lines4 = this.neuesDokument.data.tag3programm ? doc.splitTextToSize(this.neuesDokument.data.tag3programm, 79) : ''
        doc.text(lines4, 151.5, zeile + 10, {lineHeightFactor: 1.7, align: 'center'})
        doc.setFontSize(9)
        let lines5 = this.neuesDokument.data.anmerkung ? doc.splitTextToSize(this.neuesDokument.data.anmerkung, 79) : ''
        zeile = 195 - parseInt((parseInt(3) * lines5.length))
        doc.text(lines5, 151.5, zeile, null, null, 'center')
        doc.save('Einadung' + '.pdf')
      },
      printTagesordnung () {
        let doc = new JSPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4'
        })
        doc.setFont('Times')
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 90, 210, 1, 'F')
        doc.setFillColor(219, 31, 41)
        doc.rect(0, 92, 210, 1, 'F')
        let img = new Image()
        img.src = '/static/wappen.png'
        doc.addImage(img, 125, 30, 75, 75)
        doc.setFontSize(9)
        doc.text('K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn', 25, 87)
        doc.setFontSize(14)
        doc.setFont('Times', 'bold')
        this.neuesDokument.data.ueberschrift ? doc.text(this.neuesDokument.data.ueberschrift, 25, 115, null, null, 'left') : ''
        doc.setFont('Times', 'normal')
        doc.setFontSize(11)
        let zeile = 125
        let lines1 = this.neuesDokument.data.freitext1 ? doc.splitTextToSize(this.neuesDokument.data.freitext1, 160) : ''
        doc.text(lines1, 25, zeile)
        zeile += parseInt((parseInt(7) * lines1.length))
        let counter = 1
        doc.setFontSize(14)
        this.neuesDokument.data.tops.forEach(top => {
          doc.text('TOP ' + counter + ': ' + top, 25, zeile)
          zeile += 9
          counter++
        })
        zeile += 8
        doc.setFontSize(11)
        let lines2 = this.neuesDokument.data.freitext2 ? doc.splitTextToSize(this.neuesDokument.data.freitext2, 160) : ''
        doc.text(lines2, 25, zeile)
        doc.save('Tagesordnung.pdf')
      },
      printRundbriefohneansprache () {
        let doc = new JSPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4'
        })
        doc.setFont('Times')
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 90, 210, 1, 'F')
        doc.setFillColor(219, 31, 41)
        doc.rect(0, 92, 210, 1, 'F')
        let img = new Image()
        img.src = '/static/wappen.png'
        doc.addImage(img, 125, 30, 75, 75)
        doc.setFontSize(9)
        doc.text('K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn', 25, 87)
        doc.setFontSize(14)
        doc.setFont('Times', 'bold')
        this.neuesDokument.data.ueberschrift ? doc.text(this.neuesDokument.data.ueberschrift, 25, 115, null, null, 'left') : ''
        doc.setFont('Times', 'normal')
        doc.setFontSize(11)
        let zeile = 125
        let lines1 = this.neuesDokument.data.freitext ? doc.splitTextToSize(this.neuesDokument.data.freitext, 160) : ''
        for (var i = 0; i < lines1.length; i++) {
          if (zeile > 280) {
            zeile = 25
            doc.addPage()
          }
          doc.text(25, zeile, lines1[i])
          zeile += 6
        }
        doc.save('Rundbrief.pdf')
      },
      printBrief160 () {
        let doc = new JSPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4'
        })
        doc.setFont('Times')
        doc.setFillColor(39, 84, 165)
        doc.rect(0, 90, 210, 1, 'F')
        doc.setFillColor(219, 31, 41)
        doc.rect(0, 92, 210, 1, 'F')
        let img = new Image()
        img.src = '/static/logo160wappen.png'
        doc.addImage(img, 40, 18, 130, 58.32)
        doc.setFontSize(9)
        doc.text('K.D.St.V. Ripuaria Bonn | Meckenheimer Allee 146 | 53115 Bonn', 25, 87)
        doc.setFontSize(14)
        doc.setFont('Times', 'bold')
        this.neuesDokument.data.ueberschrift ? doc.text(this.neuesDokument.data.ueberschrift, 25, 115, null, null, 'left') : ''
        doc.setFont('Times', 'normal')
        doc.setFontSize(11)
        let zeile = 125
        let lines1 = this.neuesDokument.data.freitext ? doc.splitTextToSize(this.neuesDokument.data.freitext, 160) : ''
        for (var i = 0; i < lines1.length; i++) {
          if (zeile > 280) {
            zeile = 25
            doc.addPage()
          }
          doc.text(25, zeile, lines1[i])
          zeile += 6
        }
        doc.save('Rundbrief.pdf')
      }
    }
  }
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// dokumente.vue?0503b501